__webpack_require__.p = "https://na.gamma.registry.geostudio.app.amazon.dev/";